import { Box, Group, Image, Text } from '@mantine/core';

interface BrandWordmarkProps {
  /**
   * Class applied to the logo mark's wrapper. AppHeader passes its hideLogo
   * class so narrow screens drop the mark and keep the wordmark legible.
   */
  markClassName?: string;
  /**
   * Wordmark color: brand orange on light surfaces (default); dark surfaces
   * (the footer) pass "white".
   */
  c?: string;
}

/**
 * The canonical logo + wordmark row: the 32px mark beside "Meals You Love"
 * set in Plus Jakarta Sans bold (the theme default, so no fontFamily
 * override) — see docs/brand-guidelines.md in the backend repo. Render this
 * wherever the brand row appears (app header, footer, auth page) so the
 * surfaces can't drift apart again.
 */
export const BrandWordmark = ({ markClassName, c = 'orange' }: BrandWordmarkProps) => (
  <Group gap="sm" align="center" wrap="nowrap">
    <Box className={markClassName}>
      <Image src="/images/meals_you_love_logo.png" alt="Meals You Love Logo" h={32} w="auto" />
    </Box>
    <Text
      fw={600}
      fz={20}
      c={c}
      style={{ whiteSpace: 'nowrap' }}
    >
      Meals You Love
    </Text>
  </Group>
);
